var frontUrl = baseUrl;
var mktzapUrl = mktzapUrl;

// var adminApi = frontUrl + "/admin/api";
var apiUrl = frontUrl + '/api';
var loginUrl = frontUrl + '/login';
var cookie_name = 'front';
